import React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Avatar from '@mui/material/Avatar'
import { LockOutlined as LockOutlinedIcon } from '@mui/icons-material';
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link'
import { useNavigate } from 'react-router-dom'

const classes = {
}

export default function LoginProblemLinks() {
  const navigate = useNavigate()
  
  const handleNavClick = (e) => {
    let path = e.currentTarget.href.replace(/https?\:\/\//, '')
      .replace(e.currentTarget.host, '')
    navigate(path)
    e.preventDefault()
    e.stopPropagation()
  }

  return (
    <React.Fragment>
      <Box sx={{mb: 2,}}>
        <Grid container>
          <Grid sx={{ flexGrow: 1 }}>
            <Link 
              onClick={handleNavClick}
              href="/app/sign_in"
              variant="body2"
            >
              Sign in
            </Link>
          </Grid>
          <Grid>
            <Link
              onClick={handleNavClick}
              href="/app/sign_up" 
              variant="body2"
            >
              Don't have an account? Sign Up
            </Link>
          </Grid>
        </Grid>   
      </Box>

      <Box>
        <Typography variant="body2">
          <strong>
            Other login problems?
          </strong>
        </Typography>

        <ul>
          <li>
            <Link
              onClick={handleNavClick}
              href="/app/reset_password"
              variant="body2"
            >
              Forgot password
            </Link>
          </li>
          <li>
            <Link
              onClick={handleNavClick}
              href="/app/resend_login"
              variant="body2"
            >
              Forgot login
            </Link>
          </li>
          <li>
            <Link
              onClick={handleNavClick}
              href="/app/resend_confirmation"
              variant="body2"
            >
              Resend confirmation
            </Link>
          </li>
          <li>
            <Link
              onClick={handleNavClick}
              href="/app/resend_unlock"
              variant="body2"
            >
              Resend unlock instructions
            </Link>
          </li>
          <li>
            <Link
              onClick={handleNavClick}
              href="/app/openid_sign_in"
              variant="body2"
            >
              OpenID accounts
            </Link>
          </li>
        </ul>

      </Box>
    </React.Fragment>
  )
}